import { registerServiceWorker } from '@/util/register-sw';
registerServiceWorker();
import('./bootstrap').catch((err) => console.error('Error SHELL loading bootstrap:', err));
